import React from "react"
import styled from "styled-components"
import { Card } from "components/atoms/Card"
import Typography from "components/_blueprint/Typography/Typography"
import MojoMiniLogo from "url:assets/images/mojo-mini-logo-alt.svg"
import { MortgageExpertCardComponent } from "./components/MortgageExpertCard"
import { ConveyancingCardComponent } from "./components/ConveyancingCard"
import { RateCheckPromiseCard } from "./components/RateCheckPromiseCard"
import { WhatToExpectNextCard } from "./components/WhatToExpectNextCard"
import { StatusContainer } from "./shared/StyledComponents"
import { StatusData } from "./utils/statusApiUtils"

interface CoreViewProps {
  fetchedStatus?: StatusData | null
  friendlyId: string
}

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
`

const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 5px;
`

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const CardStyleOverrides = {
  borderRadius: "24px",
}

export const CoreView: React.FC<CoreViewProps> = ({ fetchedStatus, friendlyId }) => {
  // Create mortgageExpert object from API data with fallbacks
  const mortgageExpert = {
    name: fetchedStatus?.opportunityOwnerTextForEmail || "Mojo Mortgages",
    title: fetchedStatus?.flexRoles2 || "Mortgage Expert",
    email: fetchedStatus?.ownerEmailAddress || "",
    avatar: MojoMiniLogo,
  }

  return (
    <StatusContainer>
      {/* Header Section */}
      <HeaderSection>
        <Typography.H1 margin="0 0 16px 0">
          Let's get you ready for your mortgage recommendation.
        </Typography.H1>
        <Typography.LargeBody color="secondary" margin="0">
          Your expert is preparing tailored options for you.
        </Typography.LargeBody>
      </HeaderSection>

      {/* Mortgage Expert Contact Section */}
      <Card
        theme="default"
        style={CardStyleOverrides}
        content={
          <SectionContent>
            <TextContent>
              <Typography.H4 margin="0 0 8px 0">Your Mortgage Expert</Typography.H4>
              <Typography.Body color="secondary" margin="0 0 16px 0">
                Your dedicated expert is working on your mortgage recommendation. They'll be in
                touch soon with your personalized options.
              </Typography.Body>
            </TextContent>

            <MortgageExpertCardComponent mortgageExpert={mortgageExpert} />
          </SectionContent>
        }
      />

      {/* What to Expect Next Section */}
      <WhatToExpectNextCard />

      {/* Conveyancing Section */}
      <ConveyancingCardComponent friendlyId={friendlyId} />

      {/* Rate Check Promise Section */}
      <RateCheckPromiseCard friendlyId={friendlyId} />
    </StatusContainer>
  )
}
